import type { NDateLocale } from './enUS'
import { gu } from 'date-fns/locale'

const dateGuIN: NDateLocale = {
  name: 'gu-IN',
  locale: gu
}

export default dateGuIN
